import React from "react";

interface ContactProps {
  isForSharing: boolean;
  contactData: any;
  setContactData: any;
  primaryColor?: string;
  accentColor?: string;
}

const Contact: React.FC<ContactProps> = ({
  isForSharing,
  contactData,
  setContactData,
  primaryColor,
  accentColor,
}) => {
  const contactIcons = {
    phoneIcon: `https://afp-crm-qa.s3.us-east-1.amazonaws.com/Camapaign-Landing-Pages-Assets/ContactUsPhoneIcon.svg`,
    emailIcon: `https://afp-crm-qa.s3.us-east-1.amazonaws.com/Camapaign-Landing-Pages-Assets/ContactUsMailIcon.svg`,
    locationIcon: `https://afp-crm-qa.s3.us-east-1.amazonaws.com/Camapaign-Landing-Pages-Assets/ContactUsLocationIcon.svg`,
  };
  const handleSubmit = (event: any) => {
    console.log("Form submitted");
    console.log(
      "full name",
      (document.getElementById("fullName") as HTMLInputElement)?.value
    );
  };
  return (
    <div
      id="contact"
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "20px 60px 20px 60px",
      }}
    >
      <div style={{ textAlign: "center", margin: "0px 0px 10px 0px" }}>
        <h3 style={{ fontSize: "30px", margin: 0, fontWeight: "500" }}>
          {contactData.title}
        </h3>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          boxSizing: "border-box",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#ECEDF2",
            overflow: "hidden",
            margin: "0 10px 10px 10px",
            borderRadius: "12px",
            width: "75%",
            height: "100%",
          }}
          className="contact-form-container"
        >
          <div
            style={{
              backgroundColor: primaryColor,
              width: "35%",
              padding: "0 20px",
              color: "white",
            }}
            className="contact-form-container-section"
          >
            <h4
              style={{
                margin: 0,
                marginTop: "20px",
                fontSize: "18px",
                fontWeight: 500,
              }}
            >
              Get In Touch
            </h4>
            <hr />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                wordBreak: "break-word",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img src={contactIcons["phoneIcon"]} alt="Phone Icon" />
                <span>{contactData.phone}</span>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img src={contactIcons["emailIcon"]} alt="Email Icon" />
                <span>{contactData.email}</span>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img src={contactIcons["locationIcon"]} alt="Location Icon" />
                <span>{contactData.address}</span>
              </div>
            </div>
          </div>
          <div
            style={{
              width: "65%",
              padding: "20px",
            }}
            className="contact-form-container-section"
          >
            <form id="contact-us-form">
              <div style={{ marginBottom: "10px" }}>
                <input
                  name="firstName"
                  id="firstName"
                  placeholder="First Name"
                  disabled={!isForSharing}
                  style={{
                    padding: "15px",
                    width: "100%",
                    height: "60px",
                    fontSize: "16px",

                    boxSizing: "border-box",
                    border: "none",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    cursor: !isForSharing ? "not-allowed" : "auto",
                    fontFamily: "Roboto, sans-serif",
                  }}
                />
                <div
                  id="firstName-error-message"
                  className="error-message"
                ></div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <input
                  name="lastName"
                  id="lastName"
                  placeholder="Last Name"
                  disabled={!isForSharing}
                  style={{
                    padding: "15px",
                    width: "100%",
                    height: "60px",
                    boxSizing: "border-box",
                    border: "none",
                    fontSize: "16px",

                    borderRadius: "5px",
                    backgroundColor: "white",
                    cursor: !isForSharing ? "not-allowed" : "auto",
                    fontFamily: "Roboto, sans-serif",
                  }}
                />
                <div
                  id="lastName-error-message"
                  className="error-message"
                ></div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <input
                  id="contactNumber"
                  name="contactNumber"
                  placeholder="Contact Number"
                  disabled={!isForSharing}
                  onInput={(e: any) => {
                    e.target.value = e.target.value.replace(
                      /[^0-9+\-() ]/g,
                      ""
                    );
                  }}
                  style={{
                    padding: "15px",
                    width: "100%",
                    boxSizing: "border-box",
                    height: "60px",
                    border: "none",
                    fontSize: "16px",

                    borderRadius: "5px",
                    backgroundColor: "white",
                    cursor: !isForSharing ? "not-allowed" : "auto",
                    fontFamily: "Roboto, sans-serif",
                  }}
                />
                <div
                  id="contactNumber-error-message"
                  className="error-message"
                ></div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Email"
                  disabled={!isForSharing}
                  style={{
                    padding: "15px",
                    width: "100%",
                    height: "60px",
                    boxSizing: "border-box",
                    fontSize: "16px",

                    border: "none",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    cursor: !isForSharing ? "not-allowed" : "auto",
                    fontFamily: "Roboto, sans-serif",
                  }}
                />
                <div id="email-error-message" className="error-message"></div>
              </div>
              <div style={{ marginBottom: "10px" }}>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Message"
                  disabled={!isForSharing}
                  style={{
                    padding: "15px",
                    width: "100%",
                    height: "60px",
                    boxSizing: "border-box",
                    border: "none",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    fontSize: "16px",
                    cursor: !isForSharing ? "not-allowed" : "auto",
                    fontFamily: "Roboto, sans-serif",
                  }}
                />
                <div id="message-error-message" className="error-message"></div>
              </div>
              <div>
                <input
                  type="button"
                  disabled={!isForSharing}
                  style={{
                    padding: "10px",
                    width: "200px",
                    border: "none",
                    height: "50px",
                    backgroundColor: accentColor,
                    color: "white",
                    cursor: isForSharing ? "pointer" : "not-allowed",
                    borderRadius: "6px",
                    fontSize: "15px",
                    fontFamily: "Roboto, sans-serif",
                  }}
                  id="contact-submit-button"
                  onClick={(e) => {
                    handleSubmit(e);
                  }}
                  value="Submit"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
